import React from 'react';
import PropTypes from 'prop-types';
import { Icon, withStyles } from '@material-ui/core';

const IconUI_ = (props) => {
  let { style = {}, name } = props;

  const hasWhiteSpace = (s) => {
    return s.indexOf(' ') >= 0;
  };

  if (hasWhiteSpace(name)) {
    return <Icon className={name} style={style} />;
  } else {
    return <Icon style={style}>{name}</Icon>;
  }
};

const styles = () => ({});

IconUI_.propTypes = {
  //Object used to add some styling with withStyles
  classes: PropTypes.object,

  //The name of the icon
  name: PropTypes.string.isRequired,

  //Style of the icon
  style: PropTypes.object,
};

export const IconUI = withStyles(styles)(IconUI_);
